import React, { useState } from 'react';

import Chart from 'react-apexcharts';

import { formatToFixedMoneyWithLocale, formatToFixedLocaleString } from 'Helpers/formatService';

import MinusCircleIcon from 'Assets/icons/minus.svg';
import PlusCircleIcon from 'Assets/icons/plus.svg';

export default function KeyMetricsExpenditureSummary(props) {
    const [show, setShow] = useState(true);

    let colorPalette = ['#27B6FF', '#21005C', '#D8C2FF'];
    let workforceChartOptions = {};
    let allocatedChartOptions = {};

    if (Object.keys(props.summaryExpenditure).length > 0) {
        const barOptions = {
            chart: {
                fontFamily: 'var(--font-sans)',
                type: 'bar',
                height: 380,
                width: '100%',
                stacked: false,
                toolbar: {
                    tools: {
                        download: false,
                        pan: false,
                        reset: false,
                        selection: false,
                        zoom: false,
                    },
                },
            },
            tooltip: {
                y: {},
            },
            colors: colorPalette,
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                opposite: false,
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    show: false,
                },
            },
            legend: {
                show: false,
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%',
                    distributed: true,
                },
            },
            dataLabels: {
                enabled: false,
            },
        };
        workforceChartOptions = {
            ...barOptions,
            id: 'workforce-chart',
            series: [
                {
                    name: 'Workforce Chart',
                    data: [props.summaryExpenditure.percentage_non_workforce, props.summaryExpenditure.percentage_workforce],
                },
            ],
        };
        allocatedChartOptions = {
            ...barOptions,
            id: 'allocated-chart',
            series: [
                {
                    name: 'Allocated Chart',
                    data: [props.summaryExpenditure.percentage_allocated_to_venues, props.summaryExpenditure.percentage_not_allocated_to_venues],
                },
            ],
        };
    }

    return (
        <div className="tw-border-0 tw-rounded-lg tw-bg-white tw-shadow tw-h-full">
            <div className="tw-p-2.5 tw-flex tw-flex-col tw-gap-3">
                <div className="tw-flex tw-flex-row tw-justify-between tw-pb-3">
                    <div>
                        <h3 className="tw-text-blue tw-text-2xl tw-font-semibold tw-pb-1">{$t('Expenditure Summary')}</h3>
                        {Object.keys(props.summaryExpenditure).length > 0 && (
                            <h4 className="tw-text-charcoal-75 tw-text-xs tw-font-normal">
                                {$t('Expenditure Total')}: {formatToFixedMoneyWithLocale(props.summaryExpenditure.total_expenditure)}
                            </h4>
                        )}
                    </div>
                    {!show && (
                        <div className={'tw-cursor-pointer'} onClick={() => setShow(true)}>
                            <div className={'tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full'}>
                                <PlusCircleIcon className={'tw-h-3.5 tw-w-3.5 tw-text-white'} />
                            </div>
                        </div>
                    )}
                    {!!show && (
                        <div className={'tw-cursor-pointer'} onClick={() => setShow(false)}>
                            <div className={'tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full'}>
                                <MinusCircleIcon className={'tw-h-3.5 tw-w-3.5 tw-text-white'} />
                            </div>
                        </div>
                    )}
                </div>
                {Object.keys(props.summaryExpenditure).length > 0 && !!show && (
                    <div className="tw-rounded-lg tw-border-2 tw-border-gray-200">
                        <div className="tw-p-2.5">
                            <ul className={'tw-flex tw-flex-col tw-gap-1 tw-text-sm'}>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Cash')}</span>
                                    <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedLocaleString(props.summaryExpenditure.percentage_cash_expenditure)}%
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('VIK')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedLocaleString(props.summaryExpenditure.percentage_vik_expenditure)}%
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Revenue VIK vs Expenditure VIK')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedMoneyWithLocale(props.summaryExpenditure.revenue_vs_expenditure_vik)}
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Total Contingency')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedMoneyWithLocale(props.summaryExpenditure.total_contingency)}
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('% of total expenditure')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedLocaleString(props.summaryExpenditure.percentage_contingency)}%
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Allocated to venues')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedLocaleString(props.summaryExpenditure.percentage_allocated_to_venues)}%
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Not allocated to venues')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {formatToFixedLocaleString(props.summaryExpenditure.percentage_not_allocated_to_venues)}%
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
                {Object.keys(props.summaryExpenditure).length > 0 && !!show && (
                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-justify-between tw-gap-3'}>
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-6/12 max-lg:tw-w-full">
                            <div className="tw-p-2.5">
                                <div
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {Object.keys(workforceChartOptions).length > 0 && (
                                        <Chart options={workforceChartOptions} series={workforceChartOptions.series} type={'bar'} height={200} />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-6/12 max-lg:tw-w-full">
                            <div className="tw-p-2.5">
                                <div
                                    style={{
                                        position: 'relative',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {Object.keys(allocatedChartOptions).length > 0 && (
                                        <Chart options={allocatedChartOptions} series={allocatedChartOptions.series} type={'bar'} height={200} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {Object.keys(props.summaryExpenditure).length > 0 && !!show && (
                    <div className={'tw-rounded-lg tw-border-2 tw-border-gray-200'}>
                        <div className="tw-p-2.5">
                            <ul className={'tw-flex tw-flex-col tw-gap-1 tw-text-sm'}>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Number of departments / cost centres')}</span>
                                    <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                        {props.departmentsNumber} / {props.costcentresNumber}
                                    </span>
                                </li>
                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                    <span className={'tw-w-col tw-font-extrabold tw-text-blue'}>{$t('Top 3').toUpperCase()}</span>
                                </li>
                                {props.summaryExpenditure.top_3_departments_by_expenditure.map((row) => {
                                    return (
                                        <li key={'top_3_expenditure_by_departments_' + row.department_id} className={'tw-flex max-lg:tw-flex-col'}>
                                            <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.department_name}</span>
                                            <span className={' tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                {formatToFixedMoneyWithLocale(row.expenditure)} ({formatToFixedLocaleString(row.percentage)}% of total)
                                            </span>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
